function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from 'react';
import { PopupRenderer } from './PopupProvider/PopupRenderer';
import { closePopup, openPopup, resetPopup, setPopupProps, updatePopupProps } from '../store/popup/popupReducer';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { getPopupState } from '../store/popup/popupStateSelector';
export var popupContext = /*#__PURE__*/ React.createContext({
    openPopup: Function,
    setPopupProps: Function,
    resetPopup: Function,
    closePopup: Function,
    updatePopupProps: Function
});
export function usePopup(componentName, props) {
    var context = React.useContext(popupContext);
    var openPopup = React.useCallback(function() {
        context.setPopupProps(componentName, props);
        context.openPopup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    React.useEffect(function() {
        return function() {
            context.resetPopup();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return _object_spread_props(_object_spread({}, context), {
        openPopup: openPopup
    });
}
export function PopupProvider(param) {
    var children = param.children;
    var dispatch = useAppDispatch();
    var state = useAppSelector(getPopupState);
    var dispatchOpenPopup = React.useCallback(function() {
        return dispatch(openPopup());
    }, [
        dispatch
    ]);
    var dispatchClosePopup = React.useCallback(function() {
        return dispatch(closePopup());
    }, [
        dispatch
    ]);
    var dispatchResetPopup = React.useCallback(function() {
        return dispatch(resetPopup());
    }, [
        dispatch
    ]);
    var dispatchSetComponentProps = React.useCallback(function(componentName, componentProps) {
        return dispatch(setPopupProps({
            componentName: componentName,
            componentProps: componentProps
        }));
    }, [
        dispatch
    ]);
    var dispatchUpdateComponentProps = React.useCallback(function(componentProps) {
        return dispatch(updatePopupProps(componentProps));
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ React.createElement(popupContext.Provider, {
        value: {
            openPopup: dispatchOpenPopup,
            closePopup: dispatchClosePopup,
            setPopupProps: dispatchSetComponentProps,
            updatePopupProps: dispatchUpdateComponentProps,
            resetPopup: dispatchResetPopup
        }
    }, children, /*#__PURE__*/ React.createElement(PopupRenderer, state));
}
